import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/CreateQuiz/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon, Stack, Text } from 'shell/components';

const CreationHeader = () => {
    const { device } = useViewport();
    const { t } = useTranslation(['quiz', 'common']);
    const { canContinue, isSaving, step, handleBack, handleNext, handleSaveQuiz } = useContext(PageContext);
    const isMobile = device === 'mobile';

    return (
        <Stack
            component={'header'}
            direction={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            spacing={2}
            sx={(theme) => ({
                minHeight: theme.spacing(15),
                px: device === 'desktop' ? 5 : 4,
                py: 3,
                position: 'sticky',
                top: 0,
                zIndex: theme.zIndex.appBar,
                background: theme.palette.ensightful.shades[0],
                borderBottom: `1px solid ${theme.palette.ensightful.neutral[300]}`,
            })}
        >
            <Stack direction={'row'} alignItems={'center'} spacing={isMobile ? 2 : 5} sx={{ minWidth: 0 }}>
                <Button
                    variant={'borderless'}
                    startIcon={<Icon kind={'arrowLeft'} sx={{ fontSize: '1rem' }} />}
                    onClick={handleBack}
                    sx={{ flexShrink: 0 }}
                >
                    {t('common:controls.back', 'Back')}
                </Button>
                <Stack
                    direction={isMobile ? 'column' : 'row'}
                    alignItems={isMobile ? 'flex-start' : 'center'}
                    sx={{ minWidth: 0, gap: isMobile ? 1 : 2, flexWrap: 'wrap' }}
                >
                    <Text component={'h1'} variant={'sh1'} weight={'medium'} sx={{ fontSize: '1.25rem' }}>
                        {t('create.import-title', 'Import a Quiz')}
                    </Text>
                    <Text color={'light'} sx={{ fontStyle: 'italic', whiteSpace: 'nowrap' }}>
                        {t('create.step', 'Step {{step}}/3', { step })}
                    </Text>
                </Stack>
            </Stack>
            <Button
                size={'medium'}
                loading={isSaving}
                disabled={!canContinue || isSaving}
                onClick={step === 3 ? handleSaveQuiz : handleNext}
                sx={{ flexShrink: 0 }}
            >
                {step === 3 ? t('create.save-quiz', 'Save Quiz') : t('common:controls.next', 'Next')}
            </Button>
        </Stack>
    );
};

export default CreationHeader;
